export const APP_CONFIG_GLOBAL_KEY = '__NEWO_APP_CONFIG__';
